<template>
  <div class="advertisement-box show-flex-box-r">
    <div class="show-flex-box-r">
      <span>
        <img src="../../assets/home/advertisement.png" alt="德阳经开科创" draggable="false">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'advertisement_cpn',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
  .advertisement-box{
    width: 100%;
    padding-bottom: 101px;
    padding-top: 70px;
    background: #fff;
    justify-content: center;
    &>div{
      width: 1200px;
      &>span{
        overflow: hidden;
        border-radius: 12px;
        width: 100%;
        &>img{
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/advertisement_cpn.vue